import type { OngoingCall, CustomInputField, Operator, VriOngoing, VriParticipant } from '../../models/amplify/API';

export type OngoingCallView = {
  callSid: string;
  callId?: string | null;
  pin?: string | null,
  callStartedAt?: string | null;    
  callStatus?: string | null;
  clientNumber?: string | null;
  durationMilliseconds?: number | null;
  languageName?: string | null;
  outboundPhoneNumbers?: string[] | null;
  customInputFields?: CustomInputField[] | null;
  operators?: Operator[] | null;
};

export type VriOngoingView = {
  roomSid: string;
  roomStatus?: string | null;
  uniqueName?: string | null;
  callId?: string | null;
  chatSid?: string | null;
  roomCreatedAt?: string | null;
  durationMilliseconds?: number | null;
  participantsUrl?: string | null;
  participants?: VriParticipant[] | null;
};

export function nonNull<T>(x: T | null | undefined): x is T {
  return x != null;
}

export function normalizeCall(raw: OngoingCall | null | undefined): OngoingCallView | null {
  if (!raw || !raw.callSid) return null;

  return {
    callSid: raw.callSid,
    callId: raw.callId ?? null,
    pin: raw.pin ?? null,
    callStartedAt: raw.callStartedAt ?? null,      
    callStatus: raw.callStatus ?? null,
    clientNumber: raw.clientNumber ?? null,
    durationMilliseconds: raw.durationMilliseconds ?? null,
    languageName: raw.languageName ?? null,
    outboundPhoneNumbers: raw.outboundPhoneNumbers?.filter(nonNull) ?? null,
    customInputFields: raw.customInputFields?.filter(nonNull) ?? null,
    operators: raw.operators?.filter(nonNull) ?? null,
  };
}

export function normalizeVri(raw: VriOngoing | null | undefined): VriOngoingView | null {
  if (!raw || !raw.roomSid) return null;

  return {
    roomSid: raw.roomSid,
    roomStatus: raw.roomStatus ?? null,
    uniqueName: raw.uniqueName ?? null,
    callId: raw.callId ?? null,
    chatSid: raw.chatSid ?? null,
    roomCreatedAt: raw.roomCreatedAt ?? null,
    durationMilliseconds: raw.durationMilliseconds ?? null,
    participantsUrl: raw.participantsUrl ?? null,
    participants: raw.participants?.filter(nonNull) ?? null,
  };
}
